import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../../components/ui/card";
import { Activity } from "lucide-react";
import Spinner from "../../../components/ui/spinner";
import { getDetailsByRange } from "../../../services/apiservices/support";

const SupportTicketCard = ({ timeRange }) => {
  const [support, setSupport] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setSupport(0);
    setLoading(true);
    getDetailsByRange(timeRange, 'support').then((data) => {
      setSupport(data);
      setLoading(false);
    });
  }, [timeRange]);


  return (
    <Card className="bg-white dark:bg-[#2c3440]">
      <CardContent className="p-24">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="p-8 bg-blue-100 dark:bg-blue-900/20 rounded-lg mr-12">
              <Activity className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Support Tickets
              </p>
              <p className="text-2xl font-bold">
                {loading ? <Spinner size="sm" /> : `${support}`}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SupportTicketCard;
